package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
actual data class UserInfo(
    actual val id: String? = null,
    actual var authorizationToken: String? = null,
    actual var email: String? = null,
    actual var phone: String? = null,
    actual var name: String? = null,
    actual var isAdmin: Boolean? = null,
    actual var emailVerified: Boolean? = null,
    actual var picture : String?  = null,
)



